import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { FormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'
import { AgendaEmpresaRoutingModule } from './agenda-empresa-routing.module';
import { AgendaEmpresaComponent } from './agenda-empresa.component';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogsModule } from '../../../shared/dialogs/dialogs.module';
import { ProfissionalAgendaDetalheComponent } from './profissional-agenda-detalhe/profissional-agenda-detalhe.component';
import { AgendaEmpresaCalendarioComponent } from './agenda-empresa-calendario/agenda-empresa-calendario.component';
import { BloqueioDetalheComponent } from './bloqueio-detalhe/bloqueio-detalhe.component';
import { BloqueioInserirComponent } from './bloqueio-inserir/bloqueio-inserir.component';
import { AgendamentoDetalheComponent } from './agendamento-detalhe/agendamento-detalhe.component';
import { AgendaStatusStylePipe } from './pipes/agenda-status-style.pipe';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EventoInserirComponent } from './evento-inserir/evento-inserir.component';
import { AgendaEventoRenderService } from './services/agenda-evento-render.service';
import { AgendaEventoMapperService } from './services/agenda-evento-mapper.service';
import { AgendaRecursosService } from './services/agenda-recursos.service';
import { ChipModule } from 'primeng/chip'
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from "primeng/multiselect";
import { BadgeModule } from 'primeng/badge';

import { SelectServicoAgendamentoDialogComponent } from './select-servico-agendamento-dialog/select-servico-agendamento-dialog.component';
import { ClienteAgendaDetalheComponent } from './cliente-agenda-detalhe/cliente-agenda-detalhe.component';

FullCalendarModule.registerPlugins([
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin
]);


@NgModule({
  declarations: [
    AgendaEmpresaComponent,
    BloqueioDetalheComponent,
    BloqueioInserirComponent,
    ProfissionalAgendaDetalheComponent,
    AgendamentoDetalheComponent,
    AgendaEmpresaCalendarioComponent,
    AgendaStatusStylePipe,
    EventoInserirComponent,
    SelectServicoAgendamentoDialogComponent,
    ClienteAgendaDetalheComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AgendaEmpresaRoutingModule,
    FullCalendarModule,
    DialogModule,
    InputTextareaModule,
    ButtonModule,
    CalendarModule,
    InputTextModule,
    DropdownModule,
    ToastModule,
    RippleModule,
    InputMaskModule,
    MessagesModule,
    TooltipModule,
    DividerModule,
    SplitButtonModule,
    CheckboxModule,
    FormatPipeModule,
    TableModule,
    ProgressSpinnerModule,
    FormatPipeModule,
    ConfirmDialogModule,
    DialogsModule,
    RadioButtonModule,
    ChipModule,
    OverlayPanelModule,
    InputSwitchModule,
    MultiSelectModule,
    BadgeModule
  ],
  providers: [
    ConfirmationService,
    AgendaEventoRenderService,
    AgendaEventoMapperService,
    AgendaRecursosService
  ]
})
export class AgendaEmpresaModule { }
